import { useCallback, useEffect, useState } from "react";

import { env } from "../../../Constants";
import { ScreensEnum } from "../Feedback.controller";

interface UseSendWhatsAppParams {
  type: ScreensEnum;
}

export const useSendWhatsApp = ({ type }: UseSendWhatsAppParams) => {
  const [sent, setSent] = useState(false);

  const sendWhatsApp = useCallback(() => {
    setTimeout(() => {
      if (type === ScreensEnum.RESGISTRATION_PERFORMED) {
        window.location.href =
          env.take.whatsapp.url + env.take.whatsapp.text.signUp;
      }
      if (type === ScreensEnum.OPERATION_PERFORMED_SUCCESSFULLY) {
        window.location.href =
          env.take.whatsapp.url + env.take.whatsapp.text.login;
      }
    }, 3000);
  }, [type]);

  useEffect(() => {
    if (
      !sent &&
      (type === ScreensEnum.OPERATION_PERFORMED_SUCCESSFULLY ||
        type === ScreensEnum.RESGISTRATION_PERFORMED)
    ) {
      setSent(true);
      sendWhatsApp();
    }
  }, [sendWhatsApp, sent, type]);
};
